import React, { FC, SVGProps } from 'react'
import theme from 'theme'

type Props = SVGProps<SVGSVGElement>

const NewChipIcon: FC<Props> = ({ ...props }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1729_109411)">
      <path
        d="M5.72436 9.27722L5.25 10.9375L4.77564 9.27722C4.52648 8.40518 3.84482 7.72352 2.97278 7.47436L1.3125 7L2.97278 6.52564C3.84482 6.27648 4.52648 5.59482 4.77564 4.72278L5.25 3.0625L5.72436 4.72278C5.97352 5.59482 6.65518 6.27648 7.52722 6.52564L9.1875 7L7.52722 7.47436C6.65518 7.72352 5.97352 8.40518 5.72436 9.27722Z"
        stroke={theme.colors.white}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.651 5.08348L10.5 5.6875L10.349 5.08348C10.1727 4.37811 9.62189 3.82735 8.91652 3.651L8.3125 3.5L8.91652 3.349C9.62189 3.17265 10.1727 2.62189 10.349 1.91652L10.5 1.3125L10.651 1.91652C10.8273 2.62189 11.3781 3.17265 12.0835 3.349L12.6875 3.5L12.0835 3.651C11.3781 3.82735 10.8273 4.37811 10.651 5.08348Z"
        stroke={theme.colors.white}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.85498 11.9976L9.625 12.6875L9.39502 11.9976C9.26439 11.6057 8.95685 11.2981 8.56493 11.1675L7.875 10.9375L8.56493 10.7075C8.95685 10.5769 9.26439 10.2693 9.39502 9.87743L9.625 9.1875L9.85498 9.87743C9.98561 10.2693 10.2932 10.5769 10.6851 10.7075L11.375 10.9375L10.6851 11.1675C10.2932 11.2981 9.98561 11.6057 9.85498 11.9976Z"
        stroke={theme.colors.white}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1729_109411">
        <rect width="14" height="14" fill={theme.colors.white} />
      </clipPath>
    </defs>
  </svg>
)

export default NewChipIcon
